<template>
    <div>
        <div test-id="continue-card" class="p-6 my-2 bg-white shadow my-rounded">
            <div class="items-center md:flex">
                <img class="hidden w-full md:w-40 lg:block" src="https://disticloudfiles.net/img/savinfo/default/continue_card.webp" alt="">
                <div class="md:ml-3">
                    <h4 class="text-3xl font-semibold">{{$t('form.continue.formulaire_en_cours')}}</h4>
                    <p class="my-2 text-base font-light text-gray-500" v-html="$t('form.continue.un_formulaire_concernant_une_demande_de_service_apres_vente_est_deja_en_cours')"></p>
                    <div class="justify-between mt-4 md:flex">
                        <button v-if="formData" class="hidden text-sm font-light text-gray-500 cursor-pointer md:block hover:text-gray-600 hover:underline" @click="displayResumeData = !displayResumeData">
                            <span v-if="!displayResumeData">{{$t('form.continue.voir_le_dossier')}}</span>
                            <span v-if="displayResumeData">{{$t('form.continue.cacher_le_dossier')}}</span>
                        </button>
                        <div class="items-center md:flex">
                            <div class="mb-2 md:mb-0 md:mr-2">
                                <button test-id="btn-delete" class="px-3 py-2 text-sm font-light text-gray-700 duration-200 bg-red-300 border-red-300 rounded hover:bg-red-400" @click="clearFormData">
                                    {{$t('form.continue.supprimer_le_formulaire')}}<i class="ml-2 fas fa-times"></i>
                                </button>
                            </div>
                            <div>
                                <button test-id="btn-continue" class="px-3 py-2 text-sm font-light text-white duration-200 bg-green-500 border-green-500 rounded hover:bg-green-600" @click="continueForm">
                                    {{$t('form.continue.continuer')}}<i class="ml-2 fas fa-check"></i>
                                </button>
                            </div>
                        </div>
                        <div v-if="formData" class="pt-3 mt-3 border-t border-gray-200 md:hidden">
                            <button class="w-full p-3 text-sm font-light text-left text-gray-500 bg-gray-100 border border-gray-200 rounded" @click="displayResumeData = !displayResumeData">
                                <span class="flex items-center justify-between" v-if="!displayResumeData">
                                    {{$t('form.continue.12')}}
                                    <i class="fas fa-chevron-down"></i>
                                </span>
                                <span class="flex items-center justify-between" v-if="displayResumeData">
                                    {{$t('form.continue.13')}}
                                    <i class="fas fa-chevron-up"></i>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="displayResumeData && formData">
                <div class="w-full p-3 mt-2 bg-gray-100 border border-gray-200 rounded">
                    <div class="my-3" v-if="getBlock('group').result">
                        <label class="mb-0 text-gray-600 font-weight-light">{{$t('form.continue.categorie')}}</label><br />
                        <b>{{getBlock('group').result.label}}</b>
                    </div>
                    <div class="mb-3" v-if="getBlock('family') && getBlock('family').result">
                        <label class="mb-0 text-gray-600 font-weight-light">{{$t('form.continue.sous_categorie')}}</label><br />
                        <b>{{getBlock('family').result.label}}</b>
                    </div>
                    <div class="mb-3" v-if="getBlock('brand') && getBlock('brand').result">
                        <label class="mb-0 text-gray-600 font-weight-light">{{$t('form.continue.marque')}}</label><br />
                        <b>{{getBlock('brand').result.label}}</b>
                    </div>
                    <div class="mb-3" v-if="getBlock('categ') && getBlock('categ').result">
                        <label class="mb-0 text-gray-600 font-weight-light">{{$t('form.continue.type')}}</label><br />
                        <b>{{getBlock('categ').result.label}}</b>
                    </div>
                    <div class="mb-3" v-if="getBlock('app').result">
                        <label class="mb-0 text-gray-600 font-weight-light">{{$t('form.continue.produit')}}</label><br />
                        <b>
                            <span v-if="getBlock('app').result[0].value['Modele']">[{{getBlock('app').result[0].value['Modele']}}]</span>
                            {{getBlock('app').result[0].value['description']}}
                        </b>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormTool from '@/tools/FormTool'

export default {
    data() {
        return {
            formData: null,
            productIsOpen: true,
            displayResumeData: false
        }
    },
    methods: {
        getBlock(keyname) {
            return this.formData.blocks.find(block => block.key === keyname)
        },
        clearFormData() {
            localStorage.removeItem('form-data')
            if (this.$route.name == 'home') {
                this.$router.go()
            } else {
                this.$router.push({name: 'home'})
            }
        },
        continueForm() {
            this.$router.push({name: 'form.home'})
        }
    },

    mounted() {
        this.formData = JSON.parse(localStorage.getItem('form'))
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/processes/cards/other/ContinueCard.vue